import { CheckCircle2, XCircle } from "lucide-react";

const KNOWN = ["Simple gagnant", "Simple placé", "Simple Gagnant/Placé", "Gagnant-placé"];
const hasWin = (t) => t === "Simple gagnant" || t === "Simple Gagnant/Placé" || t === "Gagnant-placé" || !KNOWN.includes(t || "");
const hasPlace = (t) => t === "Simple placé" || t === "Simple Gagnant/Placé" || t === "Gagnant-placé" || !KNOWN.includes(t || "");

function Badge({ label, ok }) {
  return (
    <span
      data-testid={`result-badge-${label.toLowerCase()}-${ok ? "ok" : "ko"}`}
      className={`flex items-center gap-1 text-xs font-black px-2.5 py-1 rounded-md ${
        ok ? "bg-[#39FF14]/15 text-[#39FF14]" : "bg-[#FF3B30]/15 text-[#FF3B30]"
      }`}
    >
      {ok ? <CheckCircle2 size={14} /> : <XCircle size={14} />} {label}
    </span>
  );
}

// Affiche les badges Gagnant / Placé selon le type de pari et le résultat.
export default function PronoResult({ course }) {
  if (course.status !== "settled") return null;
  if (course.non_partant) {
    return (
      <span data-testid={`prono-np-${course.id}`} className="flex items-center gap-1 text-xs font-black px-2.5 py-1 rounded-md bg-[#FFD400]/15 text-[#FFD400]">
        <XCircle size={14} /> Non partant
      </span>
    );
  }
  const type = course.type_pari || "";
  const showWin = hasWin(type);
  const showPlace = hasPlace(type);
  return (
    <div className="flex items-center gap-1.5 flex-wrap" data-testid={`prono-result-${course.id}`}>
      {showWin && <Badge label="Gagnant" ok={!!course.won} />}
      {showPlace && <Badge label="Placé" ok={!!course.place} />}
    </div>
  );
}
